<template>
  <div class="draw-lottery" :style="{order:h5ConfigDetails[0]['modalOrder']['DrawLotteryOrder'][0]}">
    <div class="times-btn" :style="`color:${h5ConfigDetails[0]['drawLotteryConfig']['lotteryTimesFontColor'][0]};background:${h5ConfigDetails[0]['drawLotteryImg']['lotteryTimesBtn'][0]};`">
      <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['drawLotteryImg']['lotteryTimesBtn'][0]}`" alt="">
      <span :style="`color:${h5ConfigDetails[0]['drawLotteryConfig']['lotteryTimesFontColor'][0]};`">剩余抽奖次数：{{lotteryTimes}}</span>
    </div>
    <img @click='_click_lottery()' class="lottery-btn" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['drawLotteryImg']['lotteryBtn'][0]}`" alt="">
    <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['drawLotteryImg']['drawLotteryBg'][0]}`" alt="">
    
    <!-- 翻牌动画 -->
    <lottery-animation ref="lotteryAnimation" @showLottery='_show_lottery'></lottery-animation>
    <!-- 中奖弹窗 -->
    <draw-winning ref="drawWinning"></draw-winning>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import { global } from '@/config/global'
import { postCouponByCouponId, postCouponByActivityId } from '@/service/apis' //
import DrawWinning from '@/components/modal/DrawWinning'
import LotteryAnimation from '@/components/modal/LotteryAnimation'
import { $isXunMengTu, $isArrayEmptyOrAllElementsEmpty } from '@/util/util'

export default {
  name: 'DrawLottery',
  props: ['login'],
  data () {
    return {
      baseUrl,
      lotteryTimes: 0, // 剩余抽奖次数
      prizeTimes: []
    }
  },
  components: {
    DrawWinning, LotteryAnimation
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath', 'isLogin', 'userInfo', 'activityConfig', 'couponsHistory', 'activityID', 'llkSwitchOn', 'isInIos']),
    ...mapGetters([
      'isBinded'
    ])
  },
  created () {
  },
  mounted () {
  },
  watch: {
    'prizeTimes.length': {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.lotteryTimes = newVal
        }
      }
    }
  },
  methods: {
    init () {
      let mainCoupons = ''
      for (let i = 0; i < this.activityConfig.activityCoupons.length; i++) {
        let value = this.activityConfig.activityCoupons[i].couponId;
        if (value) {
          mainCoupons += value + ',';
        }
      }
      mainCoupons = mainCoupons.split(',')
      // 筛选出本次活动主礼包，去重
      let mainCouponsArr = mainCoupons.filter(function(item, index) {
        return item !== '' && mainCoupons.indexOf(item) === index
      })
      // 根据主礼包id筛选用户礼包历史
      let thisTimeHistory = !!this.couponsHistory.exchangeHistoryList && this.couponsHistory.exchangeHistoryList.filter(function(item) {
        return mainCouponsArr.indexOf(item.couponId) !== -1
      });
      this.prizeTimes = thisTimeHistory && thisTimeHistory.filter(function(item) {
        return (item.couponStatus === 0 || item.couponStatus === 3) && item.serverTime < item.useTime.to
      });
      this.lotteryTimes = this.prizeTimes.length
    },
    // 点击抽奖
    _click_lottery () {
      if (!this.isLogin) {
        return this.login()
      }

      if (this.llkSwitchOn && !this.isBinded) {
        this.$toast('请先绑定游戏账号', 3000)
        return
      }

      this.$store.commit('SET_CLICK_LOTTERY_BTN')

      // 未配置“购买浮层”时，点击抽奖次数为0的抽奖按钮无反应
      if (!this.lotteryTimes && ((this.isInIos && $isArrayEmptyOrAllElementsEmpty(this.h5ConfigDetails[0].buyPop['ios-flag'])) 
          || (!this.isInIos && $isArrayEmptyOrAllElementsEmpty(this.h5ConfigDetails[0].buyPop['android-flag'])))) {
        return
      }

      if (!this.lotteryTimes) {
        if($isXunMengTu()){
          this.$toast('您还未获得抽奖机会')
        } else {
          this.$sensors.track('app_page_click', {button_name: 'raffle', click_result: 'no_qualification'})

          return this.$parent.$refs.payPanelBottom.show()
        }
      } else {
        this.$refs.lotteryAnimation.show()
      }
    },
    _show_lottery () {
      // 判断是否一次性抽奖（一次消耗所有抽奖机会）
      if (Number(this.activityConfig.clientParams.redeemAll)){
        this._post_all_coupons()
      } else {
        this._post_coupon_to_server(this.prizeTimes.pop())
      }
    },
    // 兑换礼包
    async _post_coupon_to_server (coupon) {
      try {
        let res = await postCouponByCouponId(this.userInfo.userId, coupon.couponId)
        // this.prizeHisChange()
        let info = [] // 中奖弹窗中的数据

        // 返回内容不符合预期
        if (res.resultCode !== 0) {
          this.$sensors.track('app_page_click', {button_name: 'raffle', click_result: 'fail'})
          this.$parent.$refs.errorWin.show(`${global.ERROR_INTERFACE_POSTCOUPON}-${global.ERROR_CODE_UNKNOW_RESULT}`)
        } else {
          this.$sensors.track('app_page_click', {button_name: 'raffle', click_result: 'success'})
          let name = res.subCoupons[res.name]['desc']
          let activityCoupons = {}
          this.activityConfig.activityCoupons.forEach((ele) => {
            activityCoupons = Object.assign(activityCoupons, ele.couponClientParas)
          })
          let index = activityCoupons[res['name']]
          info.push({
            'name': name,
            'imgIndex': index
          })
          this.$refs.drawWinning.show(info)
        }
      } catch (error) {
        this.$parent.$refs.errorWin.show(`${global.ERROR_INTERFACE_POSTCOUPON}-${error.message}`)
      }
    },
    // 兑换全部礼包
    async _post_all_coupons () {
      try {
        console.log(this.couponsHistory)
        let res = await postCouponByActivityId(this.userInfo.userId, this.activityID)
        // let res = {
        //   "couponDescList": [
        //       "desc1",
        //       "desc2",
        //       "desc3",
        //       "desc4"
        //     ]
        // }
        this.$parent._init_coupons_data() // 刷新抽奖机会
        let info = res.couponDescList // 中奖弹窗中的数据
        this.$refs.drawWinning.show(info)
      } catch (error) {
        this.$parent._init_coupons_data() // 刷新抽奖机会
        this.$parent.$refs.errorWin.show(`${global.ERROR_INTERFACE_POSTCOUPON}-${error.message}`)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .draw-lottery{
    position: relative;
    font-size: 0;
    .bg{
      width: 100%;
      height: auto;
      display: block;
    }
    .times-btn{
      position: absolute;
      bottom: 6.4rem;
      width: 16rem;
      height: 3rem;
      left: 0;
      right: 0;
      margin: auto;
      font-size: 1.4rem;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      line-height: 1.64rem;
      letter-spacing: .1rem;
      color: rgba(255, 219, 147, 1);
      &>img {
        width: 100%;
        height: 100%;
      }
      &>span {
        position: absolute;
        left: 2.3rem;
        bottom: 0.7rem;
        line-height: 2rem;
      }
    }
    .lottery-btn{
      position: absolute;
      bottom: 1.5rem;
      width: 18rem;
      height: 5rem;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
</style>